﻿var $fbLoginBtn = $("#fbLoginBtn");

window.fbAsyncInit = function () {

	FB.init({
		appId: $fbLoginBtn.data("fbAppId"),
		cookie: true,  // enable cookies to allow the server to access the session
		xfbml: true,  // parse social plugins on this page
		version: $fbLoginBtn.data("fbGraphApiVersion")
	});
};

// Load the SDK asynchronously
(function (d, s, id) {
	var js, fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) return;
	js = d.createElement(s); js.id = id;
	js.src = "//connect.facebook.net/en_US/sdk.js";
	fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

$fbLoginBtn.on("click", function () {
	fbLogin();
});

function fbLogin() {
	FB.login( function (fbLoginResponse) {
		if (fbLoginResponse.authResponse) {

			$.ajax({
				type: "POST",
				url: $("body").data("secureDomain") + "/facebook/login",
				data: {
					fbId: fbLoginResponse.authResponse.userID,
					fbAccessToken: fbLoginResponse.authResponse.accessToken
				},
				dataType: "json",
				success: function (data) {
					switch (data.Status) {
						case "Ok":
							window.location.replace($("#returnUrl").val());
							break;
						case "NoLinkedAccount":
							if (data.Data.accountExistsWithFbEmail) {
								window.location.replace($("body").data("secureDomain") + "/facebook/login" + location.search + (location.search === "" ? "?email=" : "&email=") + data.Data.email);
							} else {
								window.location.replace($("body").data("secureDomain") + "/facebook/login" + location.search);
							}
							break;
						default:
							alert($fbLoginBtn.data("fbErrorText"));
							$("#fbLoginBtn").addClass("noDisplay");
							break;
					}
				},
				error: function (data) {
					alert($fbLoginBtn.data("fbErrorText"));
					$("#fbLoginBtn").addClass("noDisplay");
				}
			});

		}
		else {
			// User cancelled login or did not fully authorize.
		}
	}, { auth_type: "rerequest", scope: $fbLoginBtn.data("fbPermissions"), return_scopes: true });
}